var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5266_23953)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8797 10.8344H12.0391C11.9734 10.8344 11.9188 10.8891 11.9188 10.9547V11.9203H2.07969V2.07969H11.9203V3.04531C11.9203 3.11094 11.975 3.16563 12.0406 3.16563H12.8813C12.9469 3.16563 13.0016 3.1125 13.0016 3.04531V1.47969C13.0016 1.21406 12.7875 1 12.5219 1H1.47969C1.21406 1 1 1.21406 1 1.47969V12.5203C1 12.7859 1.21406 13 1.47969 13H12.5203C12.7859 13 13 12.7859 13 12.5203V10.9547C13 10.8875 12.9453 10.8344 12.8797 10.8344ZM13.1703 6.90156L10.9531 5.15156C10.8703 5.08594 10.75 5.14531 10.75 5.25V6.4375H5.84375C5.775 6.4375 5.71875 6.49375 5.71875 6.5625V7.4375C5.71875 7.50625 5.775 7.5625 5.84375 7.5625H10.75V8.75C10.75 8.85469 10.8719 8.91406 10.9531 8.84844L13.1703 7.09844C13.1853 7.08675 13.1973 7.07181 13.2056 7.05475C13.214 7.0377 13.2183 7.01897 13.2183 7C13.2183 6.98103 13.214 6.96231 13.2056 6.94525C13.1973 6.9282 13.1853 6.91326 13.1703 6.90156V6.90156Z",
    fill: "#096DD9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5266_23953"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportFileIcon);
export default __webpack_public_path__ + "static/media/ExportFileIcon.4a3fe3e0679a46490d6fb0bd51668171.svg";
export { ForwardRef as ReactComponent };